import * as React from 'react';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import Cookies from 'universal-cookie';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getMobileBrowserOS } from '../../redux/modules/browser';
import { isUserLoggedIn } from '../../redux/modules/user';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

const cookie = new Cookies();
const COOKIE_NAME = 'dismissableMobileBanner';

const isBannerDismissed = () => {
    const hasBeenChecked = cookie.get(COOKIE_NAME);
    return 'dismissed' === hasBeenChecked;
};

const setCookieChecked = (forceUpdate: Function): void => {
    const cookieMaxAge = 86400 * 30; // 30 days
    cookie.set(COOKIE_NAME, 'dismissed', { maxAge: cookieMaxAge });
    forceUpdate();
};

const DismissableGetMobileBanner = () => {
    const mobileBrowserOS = useSelector(getMobileBrowserOS);
    const userLoggedIn = useSelector(isUserLoggedIn);
    const { pathname } = useLocation();
    const isCheckoutPage = pathname.includes('checkout');
    const biddingConsole = pathname.includes('/console/');

    const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

    if (biddingConsole || isCheckoutPage || !userLoggedIn || mobileBrowserOS === '' || isBannerDismissed()) {
        return null;
    }

    const navTo =
        mobileBrowserOS === 'ios'
            ? 'https://itunes.apple.com/us/app/live-auctions/id321243082'
            : 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and';

    return (
        <StyledMobileBanner id="mobileBanner">
            <StyledImage alt="mobile" src="https://p1.liveauctioneers.com/dist/images/mobile_icon.png" />
            <StyledNotificationTextDiv>
                <FormattedMessage id="get_notifications_from_favorite_auctioneers" />
            </StyledNotificationTextDiv>
            <StyledAppButton external url={navTo}>
                <FormattedMessage id="get_app" />
            </StyledAppButton>
            <StyledIcon icon={faTimes} onClick={() => setCookieChecked(forceUpdate)} />
        </StyledMobileBanner>
    );
};

export default DismissableGetMobileBanner;

const StyledMobileBanner = styled.div`
    display: flex;
    height: 63px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.blue100};
    align-items: center;
    justify-content: space-around;
    position: relative;
    padding-right: 36px;
    padding-left: 16px;
`;

const StyledImage = styled.img`
    display: flex;
    max-height: 42px;
    max-width: 42px;
    border-radius: 5px;
`;

const StyledNotificationTextDiv = styled.div`
    text-align: center;
    max-width: 180px;
    font-family: ${({ theme }) => theme.typography.fontSecondary};
    line-height: 18px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.grey500};
    font-size: 14px;
`;

const StyledAppButton = styled(ButtonLink)`
    display: flex;
    width: 76px;
    height: 26px;
    background-color: ${({ theme }) => theme.colors.blue100};
    border: 1px solid ${({ theme }) => theme.colors.white};
    font-size: 12px;
    justify-content: center;
    padding: 0;
    line-height: normal;
    align-items: center;
`;

const StyledIcon = styled(FontAwesomeIcon)`
    display: block;
    position: absolute;
    top: 9px;
    right: 11px;
    z-index: 2;
    width: 17px !important;
    height: 17px;
    line-height: 1;
    color: ${({ theme }) => theme.colors.white};
`;
